import { useDisclosure } from "@msuite/ui/hooks";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { ReturnCarrierReconciliationListItem } from "@msuite/utils/types";
import { Fragment } from "react";
import { useParams } from "react-router";
import { useCitadel } from "@/hooks/use-citadel";
import { BookCarrierReturnModal } from "@/modals/stock/book-carrier-return-modal";

/**
 * Booking carriers back off the site — the carrier half of what the article panel does.
 *
 * The run comes from the route for the reason the article row states: a reconciliation row is one
 * carrier type's account for the *project* and names no return order.
 */
export function RowActions({ cell }: CellContext<ReturnCarrierReconciliationListItem, "actions">) {
	/** Hooks */
	const { t } = useTranslation();
	const returnOrderId = useParams().returnOrderId as string;
	const bookModal = useDisclosure();

	/** Query */
	const { citadel } = useCitadel();

	/** Computed */
	// The same three-state guard `apps/web/src/components/citadel/can.tsx` documents, against the
	// `update Stock` the carrier booking route gates on.
	const stockUpdateIsDenied = !!citadel && citadel.cannot("update", "Stock");

	/** Render */
	return (
		<Fragment>
			<RowActionsWrapper>
				{!stockUpdateIsDenied && (
					<Menu
						items={() => [
							{
								label: t("stock.return_book"),
								onClick: bookModal.onOpen,
								icon: icon("PackagePlus"),
							},
						]}
					>
						<Menu.Button />
					</Menu>
				)}
			</RowActionsWrapper>
			{bookModal.isOpen && (
				<BookCarrierReturnModal
					isOpen={bookModal.isOpen}
					onClose={bookModal.onClose}
					returnOrderId={returnOrderId}
					row={cell.row.original}
				/>
			)}
		</Fragment>
	);
}
